const state = {
	projectsStatisticsData: {
		items: [],
		totals: 0
	}
}

export default state
